<aside class="al-sidebar" [class.collapsed]="isMenuCollapsed" sidebarResize>
  <ba-menu [menuHeight]="menuHeight"
           [sidebarCollapsed]="isMenuCollapsed"
           (expandMenu)="menuExpand()"
           (menuItemClicked)="onMenuItemClicked($event)"></ba-menu>
</aside>
